/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Trail_TitleInputs */

const en_automation_trail_title = /** @type {(inputs: Automation_Trail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decision trail`)
};

const pt_br2_automation_trail_title = /** @type {(inputs: Automation_Trail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trilha de decisões`)
};

/**
* | output |
* | --- |
* | "Decision trail" |
*
* @param {Automation_Trail_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_trail_title = /** @type {((inputs?: Automation_Trail_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Trail_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_trail_title(inputs)
	return pt_br2_automation_trail_title(inputs)
});